// removed by extract-text-webpack-plugin
module.exports = {"noImage":"noImage--1NlrJ","platinum":"platinum--lJ7X-"};


//////////////////
// WEBPACK FOOTER
// ./components/Sponsor/styles.css
// module id = 994
// module chunks = 2